import React from "react";
import ReactMarkdown from "react-markdown";
import {makeStyles} from "@material-ui/core/styles";
import Image from "components/atoms/Image";
import {Box} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    markdown: {
        "& p": {
            fontFamily: theme.typography.fontFamily,
            fontSize: 19,
            marginTop: 19,
            paddingBottom: theme.spacing(1),
        },
        "& ul": {
            marginLeft: theme.spacing(4),
            paddingBottom: theme.spacing(2),
            "& li": {
                paddingTop: theme.spacing(1),
                fontFamily: theme.typography.fontFamily,
                fontSize: 19,
                marginTop: 0
            }
        },
        "& ol": {
            marginLeft: theme.spacing(4),
            paddingBottom: theme.spacing(2),
            "& li": {
                paddingTop: theme.spacing(1),
                fontFamily: theme.typography.fontFamily,
                fontSize: 19,
                marginTop: 0
            }
        },
        "& h1": {
            paddingTop: theme.spacing(2),
            color: theme.palette.text.primary,
            marginTop: 0,
            fontSize: '1.75rem',
            paddingBottom: theme.spacing(1),
            fontWeight: 750,
        },
        "& h2": {
            color: theme.palette.text.primary,
            marginTop: 0,
            fontSize: '1.5rem',
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(1),
            fontWeight: 700,
            
        },
        "& h3": {
            color: theme.palette.text.primary,
            marginTop: 0,
            fontSize: '1.25rem',
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(1),
            fontWeight: 600,
            
        },
        "& h4": {
            color: theme.palette.text.primary,
            marginTop: 0,
            fontSize: '1.15rem',
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(1),
            fontWeight: 550,
            
        }
    }
}));

export default function Markdown(props) {
    const classes = useStyles();
    
    return (<div className={classes.markdown}>
        <ReactMarkdown renderers={{
            image: ({src, alt}) => {
                return (<Box p={2} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                    <Image src={src} alt={alt} hasZoom />
                </Box>)
            },
            heading: ({level, children}) => {
                const variant = `h${level}`
                return React.createElement(variant, null, children);
            },
            sub: 'sub',
            sup: 'sup'
        }}>
            {props.children}
        </ReactMarkdown>
    </div>);
}
